import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { reducer } from './store/reducers';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LookupEffects } from './store/effects';
import { ScheduledDateEffects } from './store/schedule-date.effects';
import {
    reducer as scheduledDateReducer,
    scheduledDatesFeatureKey
} from './store/schedule-date.reducer';
import * as fromDataServices from '../data-services';
import { EntityDataService } from '@ngrx/data';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('lookups', reducer),
        StoreModule.forFeature(scheduledDatesFeatureKey, scheduledDateReducer),
        EffectsModule.forFeature([LookupEffects, ScheduledDateEffects])
    ],
    declarations: [],
    providers: [fromDataServices.Contract.ContractDataService]
})
export class LookupsModule {}
